import { render } from "./trumpetenterpriseAllocation.vue?vue&type=template&id=da2a946a&scoped=true"
import script from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"

import "./trumpetenterpriseAllocation.vue?vue&type=style&index=0&id=da2a946a&scoped=true&lang=css"
import "./trumpetenterpriseAllocation.vue?vue&type=style&index=1&id=da2a946a&lang=css"
script.render = render
script.__scopeId = "data-v-da2a946a"

export default script